'use client';

import { createContext } from 'react';

import type { StoreProviderDispatch, StoreProviderState } from './types';

const StoreContext = createContext<StoreProviderState | undefined>(undefined);
StoreContext.displayName = 'StoreContext';

const StoreDispatchContext = createContext<StoreProviderDispatch | undefined>(undefined);
StoreDispatchContext.displayName = 'StoreDispatchContext';

export { StoreContext, StoreDispatchContext };
